import { transactionApi } from "core/api";
import { Dispatch } from "../../store.types";
import * as actions from "./transaction.actions";

export const createTransaction =
  (product: string) => async (dispatch: Dispatch) => {
    dispatch(actions.isTransactionLoading({ isTransactionLoading: true }));
    try {
      const checkoutSession = await transactionApi.createTransaction(product);
      dispatch(actions.checkoutSession({ checkoutSession }));
    } catch (error: any) {
      console.error(error);
      dispatch(actions.transactionError({ transactionError: error?.msg }));
    } finally {
      dispatch(actions.isTransactionLoading({ isTransactionLoading: false }));
    }
  };

export const resetCheckoutSession = () => async (dispatch: Dispatch) => {
  dispatch(actions.checkoutSession({ checkoutSession: { url: "" } }));
};

export const confirmTransaction =
  (sessionId: string) => async (dispatch: Dispatch) => {
    dispatch(actions.isTransactionLoading({ isTransactionLoading: true }));
    try {
      await transactionApi.updateUserTransaction(sessionId);
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(actions.isTransactionLoading({ isTransactionLoading: false }));
    }
  };

export const cancelTransaction =
  (sessionId: string) => async (dispatch: Dispatch) => {
    dispatch(actions.isTransactionLoading({ isTransactionLoading: true }));
    try {
      await transactionApi.cancelUserTransaction(sessionId);
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(actions.isTransactionLoading({ isTransactionLoading: false }));
    }
  };

export const resetError = () => async (dispatch: Dispatch) => {
  dispatch(actions.transactionError({ transactionError: "" }));
};

export const createPlanTransaction =
  (product: string) => async (dispatch: Dispatch) => {
    dispatch(actions.isTransactionLoading({ isTransactionLoading: true }));
    try {
      const checkoutSession = await transactionApi.createPlanTransaction(
        product
      );
      dispatch(actions.checkoutSession({ checkoutSession }));
    } catch (error: any) {
      console.error(error);
      dispatch(actions.transactionError({ transactionError: error?.msg }));
    } finally {
      dispatch(actions.isTransactionLoading({ isTransactionLoading: false }));
    }
  };
